//#region Styles
import {
	Part,
	TitleSection,
	ParagraphSection,
	Fields,
	Column,
	Row,
} from "components/styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
//#endregion

const Part1 = ({ form, changeField, errors, isProfessionalTools, selectedCourseName }) => {
	//#region Functions
	const toggleStandOutEvent = () => {
		changeField("standOutEvent", !form.standOutEvent);
	};
	const changeTitleField = value => {
		// if(isProfessionalTools){
		// 	changeField("title", selectedCourseName, false);
		// }
		changeField("title", value, false);
	};
	const changeDescriptionField = value => {
		changeField("description", value, false);
	};
	const changeLinkDescriptionField = value => {
		changeField("linkInformacionDesc", value, false);
	};
	const changeLinkField = value => {
		changeField("linkInformacion", value, false);
	};
	//#endregion
	return (
		<Part>
			<TitleSection>Información del evento</TitleSection>
			<ParagraphSection>
				Añade la información que consideres necesaria:
			</ParagraphSection>
			<Fields>
				<Row
					rowGap="15px"
					columnGap="5px"
				>
					<CustomTextArea
						label="Título"
						placeholder="Escribe el título del evento..."
						value={form.title}
						onChange={changeTitleField}
						error={errors.title}
						errorText="Es necesario completar un título."
						maxLength={100}
						width="49%"
					/>
					<CustomTextArea
						label="Descripción"
						placeholder="Escriba la descripción del evento..."
						value={form.description}
						error={errors.description}
						errorText="Es necesario completar una descripción."
						onChange={changeDescriptionField}
						maxLength={250}
						width="49%"
					/>
				</Row>
				<Column align="flex-start">
					<CustomCheckbox
						label="Destacar evento"
						variant="switch"
						checked={form.standOutEvent}
						onChange={toggleStandOutEvent}
					/>
				</Column>
				<Column align="flex-start">
					<CustomTextInput
						label="Link de más información (opcional)"
						placeholder="Texto mostrado (max. 50 carac.)"
						value={form.linkInformacionDesc}
						onChange={changeLinkDescriptionField}
						maxLength={50}
						width="30%"
					/>
					<CustomTextInput
						placeholder="Insertar link"
						value={form.linkInformacion}
						onChange={changeLinkField}
						maxLength={500}
						width="49%"
					/>
				</Column>
			</Fields>
		</Part>
	);
};

export default Part1;
